export default __webpack_public_path__ + "static/inschat-mobile-real-f167643c814e8a6c437ac00319dcc11d.png";